import { Tooltip, useMediaQuery } from '@mui/material';

const ResponsiveTooltip = ({ title, children }) => {
  const isIgel = useMediaQuery('(max-width:1024px)');

  return isIgel ? (
    <Tooltip title={title} placement='bottom'>
      {children}
    </Tooltip>
  ) : (
    children
  );
};

export default ResponsiveTooltip;